import { defineSearch, param, type RawSearch } from '@/router/search';

/**
 * /image-resize URL state.
 *  - `sourceId` + `sourceType=creative-lab`: the Creative lab hand-off (apps/web's
 *    keys, kept so its links work). Read once, then stripped from the URL.
 *  - `operation`: the resize shown in the result pane, so a reload or a shared
 *    link reopens it.
 */
export const parseAiResizingSearch = (raw: RawSearch) => ({
  sourceId: param.string(raw, 'sourceId'),
  sourceType: param.enumValue(raw, 'sourceType', ['creative-lab'] as const),
  operation: param.string(raw, 'operation'),
});

export type AiResizingSearch = ReturnType<typeof parseAiResizingSearch>;

export const aiResizingSearch = defineSearch(parseAiResizingSearch);
